const colors = [
    { background: '#adb6e6', contrast: '#1b295a' },
    { background: '#bae6ad', contrast: '#194f17' },
    { background: '#e6deac', contrast: '#33220f' },
    { background: '#e6cfad', contrast: '#33220f' },
    { background: '#e6adad', contrast: '#1d0707' },
]

export default colors;